module.exports={render:function (){with(this) {
  return _h('div', {
    staticClass: "ion-list-header item ",
    class: ['item-' + theme, 'list-header-' + theme]
  }, [_h('div', {
    staticClass: "item-inner"
  }, [_h('div', {
    staticClass: "input-wrapper"
  }, [_t("ion-label"), " ", _h('ion-label', {
    ref: "label"
  }, [_t("default")]), " ", _t("item-content")]), " ", _t("item-right")]), " ", _m(0)])
}},staticRenderFns: [function (){with(this) {
  return _h('div', {
    staticClass: "button-effect"
  })
}}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4f33416f!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/list/src/list.header.vue
// module id = 158
// module chunks = 0